import React, { FC } from "react";
import classnames from "classnames";

import "./index.scss";
import { Icon } from "../Icon";
import { Tooltip } from "../Tooltip";

interface ContainerItemHeaderProps {
  title: string;
  subTitle?: string | React.ReactNode;
  onBack?: () => void;
  className?: string;
  rightBlock?: React.ReactNode;
  /** Accessible name AND tooltip text for the back button. Per the label convention (a control that
   *  takes you somewhere names the destination), pass "Back to settings"/"Back to teammates"/etc.
   *  wherever the caller knows where it leads; defaults to the bare "Back" for callers that don't.
   *  Has no effect without `onBack`. */
  backLabel?: string;
}

const ContainerItemHeader: FC<ContainerItemHeaderProps> = (props) => {
  const { title, subTitle, onBack, className, rightBlock, backLabel = "Back" } = props;

  return (
    <div className={classnames("container-item-header", className)}>
      <div className="container-item-header-left">
        {onBack && (
          // An icon-only button and the page heading are separate elements.
          <Tooltip text={backLabel}>
            <button type="button" className="container-item-header-back" aria-label={backLabel} onClick={onBack}>
              <Icon type="back" />
            </button>
          </Tooltip>
        )}
        {/* role="heading" gives this element real heading semantics without changing its tag, class,
            or styling, so it stays visually identical to sibling headers (which render their title as
            a plain div too) while being announced as a heading. */}
        <div className="container-item-header-title" role="heading" aria-level={1}>
          {title}
        </div>
        {subTitle && <div className="container-item-header-subtitle">{subTitle}</div>}
      </div>
      <div className="container-item-header-right">{rightBlock}</div>
    </div>
  );
};

export default ContainerItemHeader;
